import { Box, Stack, Typography, Link } from "@mui/material";
import { useSelector } from "react-redux";
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';

export const Footer = ({ handleSectionNavigation }) => {
  const number = useSelector((state) => state.supportNumbers?.landingPage);
  return (
    <Box sx={{ background: "#DDE7EF" }}>
      <Stack
        maxWidth="xl"
        direction={{ xs: "column", md: "row" }}
        justifyContent={{ xs: "center", md: "space-between" }}
        alignItems={{ xs: "center", md: "flex-start" }}
        sx={{ margin: "auto" }}
        py={{ xs: 4, md: 5 }}
        px={{ xs: 2.5, sm: 6, md: 6, lg: 12, xl: 16 }}
        spacing={{ xs: 4, md: 0 }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 2, md: 12 }}
          alignItems={{ xs: "center", sm: "flex-start" }}
        >
          <Box textAlign={{ xs: "center", sm: "left" }}>
            <Stack direction="row" spacing={2} mb={1.5} justifyContent={{ xs: "center", sm: "flex-start" }}>
              <img
                src="/assets/icons/LZ-logo-face.svg"
                alt="logo face"
                style={{ marginBottom: "2px" }}
              />
              {/* <Hidden mdDown> */}
              <img
                src="/assets/icons/LZ-logo.svg"
                alt="logo"
                style={{ marginTop: "4px" }}
              />
            </Stack>
            <Stack direction="row">
              <PhoneRoundedIcon sx={{color:'#333'}}/>
              <Typography
                variant="p"
                sx={{ color: "#333333", fontSize: ".875em", fontWeight: "500" }}
                mr={1.5}
                pt="1px"
              >
                Get in touch
              </Typography>
              <Typography
                variant="p"
                ml="auto"
                color="#0C7F44"
                sx={{ fontWeight: "bold" }}
              >
                {number}
              </Typography>
            </Stack>
          </Box>
        </Stack>

        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 3, sm: 3, lg: 5 }}
          alignItems={{ xs: "center", md: "flex-start" }}
        >
          <Stack direction="column" spacing={2.5} alignItems="center">
            <Link
              onClick={() => handleSectionNavigation("home")}
              color="#414A50"
              fontWeight="600"
            >
              Home
            </Link>
            <Link
              onClick={() => handleSectionNavigation("aboutUs")}
              color="#414A50"
              fontWeight="600"
            >
              About Us
            </Link>
          </Stack>
          <Stack direction="column" spacing={2.5} alignItems="center">
            <Link
              onClick={() => handleSectionNavigation("whyChooseUs")}
              color="#414A50"
              fontWeight="600"
            >
              Why Choose Us
            </Link>
            <Link
              onClick={() => handleSectionNavigation("thingsWeDeliver")}
              color="#414A50"
              fontWeight="600"
            >
              Things We Deliver
            </Link>
          </Stack>
          {/* <Stack direction="column" spacing={2.5} alignItems="center">
            <Link
              onClick={() => handleSectionNavigation("customer")}
              color="#414A50"
              fontWeight="600"
            >
              Customer Login
            </Link>
            <Link
              onClick={() => handleSectionNavigation("transporter")}
              color="#414A50"
              fontWeight="600"
            >
              Partner Login
            </Link>
          </Stack> */}
          <Stack direction="column" spacing={2.5} alignItems="center">
          <Link
              href="/privacypolicy"
              color="#414A50"
              fontWeight="600"
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms&conditions"
              color="#414A50"
              fontWeight="600"
            >
              Terms & Conditions
            </Link>
          </Stack>
          <Stack direction="column" spacing={2.5} alignItems="center">
          <Link
              href="/cancellations&refunds"
              color="#414A50"
              fontWeight="600"
            >
              Cancellation & Refunds
            </Link>
          
            
          </Stack>
        </Stack>
      </Stack>
      <Box sx={{ background: "#414A50", textAlign: "center" }}>
        <Typography
          color="#FFF"
          fontSize={{ xs: "0.875rem", sm: "1rem", md: "1.125rem" }}
          fontWeight="700"
          px={{ xs: 2, sm: 4 }}
          py={{ xs: 1, sm: 1.5 }}
        >
          We operate in Bengaluru and nearby regions, while expanding our
          services across India!
        </Typography>
        <Typography
          color="#Cfd8dc"
          fontSize={{ xs: "0.6875rem", sm: "0.75rem", md: "0.9rem" }}
          fontWeight="500"
          px={{ xs: 2, sm: 4 }}
          pb={{ xs: 1.5, sm: 2 }}
        >
          © 2025 LoadEazy. A trademark of Juggernaut Ventures. All rights
          reserved.
        </Typography>
      </Box>
    </Box>
  );
};
